import { render, staticRenderFns } from "./ArrowUpIcon.vue?vue&type=template&id=743a484c"
import script from "./ArrowUpIcon.vue?vue&type=script&lang=js"
export * from "./ArrowUpIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports